import React, { useState } from 'react';
import {
   Form, Select, Input, Button, notification,Modal
} from 'antd';
import Cookies from 'js-cookie';
import API from '../utils/Api';
import { finalValues } from '../shared/camp-constant-values';
import { fieldValuesCheck, throwErrors } from '../shared/camp-helper';
import { range, isEmpty, get } from "lodash";
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Option } = Select;
const { confirm } = Modal;

function emailValidation(value) {
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (!value.match(validRegex)) {
    return true;
  }
}

function mobileValidation(value) {
  if (!/^\d{10}$/.test(value)) {
    return true;
  }
}

const TestCampaign = (properties) => {
  const {
    form,
    selectCampaign,
    templateObj,
    templateExpressionCount,
    costing,
  } = properties;
  const [appID] = useState(Cookies.get('appID'));
  const [apiUrl] = useState(Cookies.get('apiUrl'));
  const [appName] = useState(Cookies.get('camp_appName'));
  const tenantId = Cookies.get("tenant_id") || "";
  const myApi = new API({});
  myApi.createEntity({ name: 'campaign' });
  const [loading, setLoading] = useState(false);
  const [appKey] = useState(Cookies.get("appKey"));
  const campaignTags = form.getFieldValue("campaign_tags");

  const testCampaign = (formData) => {
    setLoading(true);
    if (templateObj) {
      const templateObjValues = Object.values(templateObj);
      const wtParams = templateObjValues.toString();
      formData.Whatsapp = wtParams;
    }
    let wtParams = [];
    if (selectCampaign === "Whatsapp" && templateExpressionCount) {
      range(templateExpressionCount).map((index) => {
        const value = form.getFieldsValue([`Content${index + 1}`]);
        if (!isEmpty(value[`Content${index + 1}`])) {
          return wtParams.push(
            encodeURIComponent(value[`Content${index + 1}`])
          );
        } else {
          return (wtParams = []);
        }
      });
    }
  if (selectCampaign === "Whatsapp" && isEmpty(wtParams)) {
    setLoading(false);
    return notification.error({
      message: "Please enter  content value",
    });

  }
    myApi.endpoints.campaign
      .create(formData, {}, "/test-campaign")
      .then((res) => {
        const response = get(res, "data", {});
        if (response.success) {
          notification.success({ message: "Message sent successfully" });
          setLoading(false);
        } else {
          notification.error({
            message: response.message || "failed to send message",
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: err.message || "failed to send message",
        });
        setLoading(false);
      });
  };

  const onValidateFn = () => {
    const getFields = finalValues[selectCampaign];
    const type = form.getFieldValue("campaign_type");
    const selectField =form.getFieldValue("test_field")
    if (type !== "Whatsapp" && !fieldValuesCheck(getFields, form)) {
      return throwErrors(getFields, form);
    }
    if(isEmpty(selectField)){
      return throwErrors(['test_field'], form);
    }

    const formData = {
      queryField: form.getFieldValue("test_field"),
      queryValue: form.getFieldValue("test_value"),
      whatsappTemplate: form.getFieldValue("whatsappTemplate"),
      campaignType: form.getFieldValue("campaign_type"),
      appID,
      apiUrl,
      appName,
      tenantId,
      appKey,
      paymentType: form.getFieldValue("payment_type") || "Wallet",
      campaignTags
    };
    formData[formData.campaignType] =
      type !== "Whatsapp"
        ? { ...form.getFieldsValue([...finalValues[formData.campaignType]]) }
        : "";
    if (formData.queryField === "email_address") {
      if (emailValidation(formData.queryValue)) {
        return form.setFields([
          {
            name: "test_value",
            errors: ["Please enter valid email address"],
          },
        ]);
      }
      testCampaign(formData);
    }
    if (formData.queryField === 'phone_number') {
      if (mobileValidation(formData.queryValue)) {
        return form.setFields([
          {
            name: 'test_value',
            errors: ['Please enter valid phone number'],
          },
        ]);
      }
      testCampaign(formData);
    }
  };

  const renderOptions = () => {
    const type = form.getFieldValue('campaign_type');
    if (type === 'Email') {
      return (<Option value="email_address">Email address</Option>);
    }
    if (type === "Push" || type === "Whatsapp") {
      return <Option value="phone_number">Phone number</Option>;
    }
    return (
      <>
        <Option value="email_address">Email address</Option>
        <Option value="phone_number">Phone number</Option>
      </>
    );
  };

const showConfirm = () => {
  confirm({
    title:
      "* Your account will be charged for every test message sent, at the agreed Whatsapp notification rate * ?",
    icon: <ExclamationCircleOutlined />,
    okText: 'Yes',
    cancelText: 'No',
    onOk() {
      onValidateFn();
    },
    onCancel() {
    },
  });
};

  return (
    <>
      <p>Test campaign</p>
      <div className="test-grid-auto-3">
        <Form.Item name="test_field">
          <Select size="large">{renderOptions()}</Select>
        </Form.Item>
        <Form.Item name="test_value">
          <Input size="large" />
        </Form.Item>
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            onClick={() =>
              Number(costing) > 0 ? showConfirm() : onValidateFn()
            }
          >
            Test
          </Button>
        </Form.Item>
      </div>
      <p className="p-red">
        {" "}
        * Use this only to validate the message format on delivery
      </p>
    </>
  );
};

export default TestCampaign;
